export const shapeAddMembershipPayload = (args) => {
  const {
    payloadFromSC,
    inputsData: { firstName, lastName, phoneNumber },
    dropdownsData: { selectedPrefix, selectedDobDay, selectedDobMonth, selectedDobYear },
    familiesInfo,
    bequestsInfo,
    selectedMemberShip,
  } = args;

  const requestPayloadModel = {
    ...payloadFromSC,
    Account: {
      ...payloadFromSC.Account,
      Title: selectedPrefix || null,
      FirstName: firstName || null,
      LastName: lastName || null,
      DOBDay: selectedDobDay || null,
      DOBMonth: selectedDobMonth || null,
      DOBYear: selectedDobYear || null,
      PhoneNumber: phoneNumber || '',
    },
    FamiliesInfo: familiesInfo,
    BequestsInfo: bequestsInfo,
    SelectedMemberShip: selectedMemberShip,
    SelectedPrefixDesc: selectedPrefix || null,
  };

  return requestPayloadModel;
};
